<template>
<div>
  <div class="trainer" v-show="!reaction">
    <div class="trainer__header">
      <a class="trainer__back" href="#" @click.prevent="onStopTrainer">◄ Назад</a> 

      <div class="train__info" v-if="active">
        <div class="train__item" uk-tooltip="Ошибок сделано">
          <div class="train__ico train__ico--2"></div>
          <small>Ошибок:</small>
          {{ errors }}
        </div>
        <div class="train__item" v-if="$route.params.isHomework" uk-tooltip="Выполнено упражнений">
          <div class="train__ico train__ico--4"></div>
          <small>Выполнено:</small>
          <div class="train__nowrap">{{ $route.params.total }} из {{ $route.params.qnt }}</div>
        </div>
        <div class="train__item" uk-tooltip="Времени прошло">
          <div class="train__ico train__ico--3"></div>
          <div>
            <small>Времени прошло:</small>
            <!--<br class="uk-visible@s">-->
            {{ timer.minutes }} мин. {{ timer.seconds }} сек.
          </div>
        </div>
      </div>

      <div class="fly__steps">
        <p v-if="!start_game">Дракон пытается убежать! Попробуй найти его!<br>Нажимай кнопку Начать, когда будешь готов!</p>
        <div class="fly__step" :class="step_key" v-if="current_step"><span class="">{{ current_step }}</span></div>
        <p v-if="steps_end">В какой клетке спрятался дракоша?<br>Нажими на клетку, чтобы проверить!</p>
        <a href="#" @click.prevent="letStartGame()" v-if="!start_game">Начать!</a>                
      </div>
    </div>

    <div class="trainer__body">
      <div v-if="params.finish" class="finish-block">
        <p class="scores">Заработано <strong>{{ scores }}</strong> {{ $root.getNoun(scores, 'балл', 'балла', 'баллов') }}!</p>
        <button class="uk-button uk-button-primary" @click="startGame" v-if="!checkFinishHomework()">Повторить!</button>
        <button class="uk-button uk-button-primary" @click="onStopTrainer" v-else>Закончить</button>
      </div> 
      <div class="fly__gridwrap">
        <ul class="fly__hor">
          <li v-for="i in +params.size" :key="i.id" :style="`width: calc(500px / ${+params.size});`">{{ alph[i-1] }}</li>
        </ul>
        <ul class="fly__ver">
          <li v-for="i in +params.size" :key="i.id">{{ i }}</li>
        </ul>
        <ul class="fly__grid" :style="`grid-template: repeat(${ params.size }, 1fr) / repeat(${ params.size }, 1fr);`">
          <li v-for="i in (params.size * params.size)" :key="i.id" @click="checkAnswer(i)" :class="i === currentPosition ? 'active' : ''">
            <!--<span :class="i === currentPosition ? 'active' : ''">{{ i }}</span>-->
            <img src="storage/app/media/drako_move.gif" alt="" v-if="((i === center) && !start_game) || (user_answer && finish && (i === currentPosition))">
            <img src="storage/app/media/wrong.png" alt="" v-if="(user_answer === i) && (user_answer !== currentPosition) && finish">

          </li>
        </ul>
      </div>
    </div>       
  </div>

  <div class="wh-block wh-block--reaction" v-if="reaction">
    <div class="reaction">
      <!--<video loop muted preload="auto" autoplay>-->
      <video disableRemotePlayback preload="auto" autoplay @ended="stopReaction">
        <source type="video/mp4" :src="'/storage/app/media/reactions/' + reaction_file" id="mp4">
      </video>
    </div>
  </div>
</div>
</template>

<script>
import {
  mapState,
  mapMutations
} from 'vuex';
import {
  mix
} from "./../mixin";
import {
  soundMix
} from "../../../mixins/sound";
import axios from 'axios'

export default {
  name: "game",
  mixins: [
    mix, soundMix
  ],
  data() {
    return {
      /** NEW METHODS */
      table: '',
      center: '',
      currentPosition: '',
      steps: '',
      local_steps: 0,
      results: [],
      local_results: [],
      stat_id: '',
      current_step: '',
      step_key: '',
      user_answer: '',
      actions: ['Вверх ↑', 'Вправо →', 'Вниз ↓', 'Влево ←'],
      alph: ['А', 'Б', 'В', 'Г', 'Д', 'Е', 'Ж', 'З', 'И', 'К'],
      canOut: false,
      start_game: false,
      steps_end: false,
      /** OLD */
      cifs: '',
      shuffle: '',
      active: false,
      step: 0,
      errors: 0,
      nextCif: '',
      currentCif: '',
      reaction: false,
      scores: 0,
    }
  },
  computed: {
    ...mapState({
      params: state => state.train.bee_params
    }),
    finish() {
      return this.params.finish
    },
    // questions
    user() {
      return this.$store.state.user;
    },
    success() {
      return this.user_answer === this.currentPosition;
    }
  },
  methods: {
    /** NEW METHODS */
    makeTable() {
      let size = this.params.size;
      let table = new Array(size);
      let n = 1;
      for (let i = 0; i < size; i++) {
        //table[i] = new Array(size);
        table[i] = [];
        for (let y = 0; y < size; y++) {
          table[i].push(n);
          n++;
        }
      }
      this.center = Math.ceil((size * size) / 2);
      this.currentPosition = this.center;
      this.table = table;
    },
    clickBlock(i) {
      console.log(i);
      let table = this.table;
      let size = this.params.size;
      let y = Math.ceil(i / size);
      let x = (i % size) === 0 ? size : (i % size);
      //console.log(x, y, table[x - 1][y - 1]);
    },
    getSteps() {
      let qnt = this.params.min_steps;
      let steps = [];
      for (let i = 0; i < qnt; i++) {
        let step = this.getStep();
        steps.push(step);
      }
      this.steps = steps;
      console.log(steps);
    },
    getStep() {
      let step = _.sample(this.actions);
      //console.log('Get Step', step);
      if (this.checkPosition(step)) {
        //console.log(step);
        //console.log('Get Step возвращаем', step);
        return step;
      } else {
        //console.log('Get Step переигрываем');
        return this.getStep();
      }
    },
    checkPosition(step) {
      let move = this.letMove(step);
      //console.log('Check position', move);
      if (move) {
        this.currentPosition = move;
        return true;
      }
      return false;
    },
    letMove(step) {
      //console.log('Let move', step);
      //console.log('Текущая позиция', this.currentPosition);
      let table = this.table;
      let size = this.params.size;
      let currentPos = this.currentPosition;
      let y = Math.ceil(currentPos / size) - 1;
      let x = ((currentPos % size) === 0 ? size : (currentPos % size)) - 1;

      switch (step) {
        case 'Вверх ↑':
          y = y - 1;
          break;
        case 'Вниз ↓':
          y = y + 1;
          break;
        case 'Влево ←':
          x = x - 1;
          break;
        case 'Вправо →':
          x = x + 1;
          break;
      }

      if (!this.canOut) {
        if (x > (size - 1) || x < 0 || y > (size - 1) || y < 0) {
          return false;
        }
      }
      return table[y][x];
    },
    prepareField() {
      let params = this.params;
      if (params.mode === 'where') {
        this.canOut = false;
      }
    },
    async letStartGame() {
      this.start_game = true;
      await this.countDown();
      this.startTimer();
      this.showSteps();
    },
    async countDown() {
      let arr = ['На старт!', 'Внимание', 'Марш!'];
      let app = this;

      function setStep(currentStep) {
        app.current_step = currentStep;
        app.step_key = 'ready';
        app.playBeeSound('cif1');
      }

      setStep('На старт!');
      for (let i = 1; i < 3; i++) {
        await this.sleep(1000);
        setStep(arr[i]);
      }
      await this.sleep(1000);
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    showSteps() {
      let steps = this.steps;
      let speed = this.params.speed;

      let timer;
      let app = this;

      function reading(currentStep = 0) {
        app.current_step = '';
        if (currentStep >= steps.length || !app.params.start) {
          console.log('finish');
          app.steps_end = true;
          return;
        } else {
          app.current_step = steps[currentStep];
          app.step_key = (currentStep % 2 === 0) ? 'odd' : 'even';
          app.playBeeSound('cif2');
          currentStep++;
          timer = setTimeout(reading, (speed * 1000), currentStep);
        }
      }

      reading();

    },
    checkAnswer(i) {
      if (this.steps_end && !this.params.finish) {
        this.user_answer = i;

        this.startReaction();

        if (this.success) {
          this.playBeeSound('yes1');
        } else {
          this.playBeeSound('no');
          this.errors++;
        }

        if (!this.params.show_reactions) {
          if (i === this.currentPosition) {
            console.log('Правильно!');
            swal('Правильно!', 'Дракоша найден!', 'success');
          } else {
            console.log('Неправильно!');
            swal('Не вышло!', 'Дракоша смог от тебя спрятаться! Попробуй еще разок!', 'error');
          }
        }

        this.addScores();

        let result = {
          position: this.currentPosition,
          user_answer: +this.user_answer,
          timer: this.timer
        };
        this.results.push(result);
        this.local_results.push(result);

        if (this.local_steps > 1 && this.stat_id) {
          this.updateStats();
        } else {
          this.makeStats();
        }
        this.params.finish = true;
      }
    },

    /** OLD */

    stopGame() {
      this.active = false;
      this.$parent.commitVal(true, 'finish');
    },

    startGame() {
      this.makeTable();
      this.prepareField();
      this.getSteps();

      this.scroll();
      this.local_steps++;
      this.user_answer = '';
      this.start_game = false;
      this.params.finish = false;
      this.step = 0;
      //this.errors = 0;
      this.active = true;
      this.steps_end = false;
    },
    addScores() {
      let sum = 0;
      if (this.user_answer === this.currentPosition) {
        let coeff = 0;
        switch (+this.params.size) {
          case 3:
            coeff = 1;
            break;
          case 5:
            coeff = 1.2;
            break;
          case 7:
            coeff = 1.4;
            break;
        }
        let scores = coeff * (+this.params.min_steps / +this.params.speed);

        sum = Math.ceil(scores);

        console.log(coeff, scores, sum);

        if (this.$route.params.isHomework) {
          sum = Math.ceil(sum * this.$store.state.hw_coefficient);
        }
        this.checkScoreStatus(sum);
      } else {
        console.log('Ошибка');
      }
      this.scores = sum;
      this.$store.commit('changeUserScores', sum);
      console.log('Баллов заработано', sum);
    },
    async makeStats() {
      if (this.user.role.code === 'student') {
        
        let path = this.$route.params.is_matrius ? 'onSaveMatriusAnswer' : 'onSaveStats'
        console.log('Бережно сохраняем статистику', path);
        let time = this.timer;
        let errors = this.errors;
        let train_params = this.params;
        let stats = {
          total: this.getTotalTime(this.local_results),
          results: this.results,
          time: time,
          errors: errors,
          count: this.local_steps,
          user_id: this.$store.state.user.id,
          trainer: this.$store.state.current_trainer.id,
          scores: this.scores,
          train_params: {
            speed: train_params.speed,
            steps: train_params.min_steps,
            size: +train_params.size
          }
        }
        stats = this.checkHomework(stats);
        
        if (this.$route.params.is_matrius) {
          stats.student_task_id = this.$route.params.student_task_id
          stats.qnt = this.$route.params.qnt
        }
        let data = {
          'stat': stats
        }        
        this.http.post(path, data).then((res) => {
          this.stat_id = res.id;
          this.checkCoins(res.data);

          if (this.$route.params.is_matrius && res.data.is_done) {
            swal('Успешно!', res.data.message, 'success')
          }
        })
        .catch(e => swal('Что-то пошло не так', '' + e, 'error'))

      } else {
        console.log('Учителей в статистику не заносим! Понятно?!');
      }
    },

    getTotalTime(arr) {
      return _.reduce(arr, function (sum, i) {
        return sum + i.timer.total_ms;
      }, 0);
    },

    async updateStats() {
      if (this.user.role.code === 'student') {
        console.log('Update stats');
        let time = this.getTotalTime(this.local_results);
        let stat_id = this.stat_id;
        let arr = {
          results: this.results,
          time: time,
          errors: this.errors,
          stat_id: stat_id,
          count: this.local_steps,
          scores: this.scores,
          isHomework: this.$route.params.isHomework ? true : false
        }
        let data = {
          'stat': arr
        }
        this.updateHomework();

        let res = await this.http.post('onUpdateStats', data).then(res => res.data);
        this.checkCoins(res);
      }
    },

    /** РЕАКЦИИ */
    startReaction() {
      if (this.params.show_reactions) {
        let type = (this.user_answer === this.currentPosition ? 'react_plus' : 'react_minus');
        this.reaction_file = this.checkReaction(type);
        this.reaction = true;
      }
    },
    stopReaction() {
      this.reaction = false;
      let app = this;
      setTimeout(function () {
        app.scroll();
        $('#repeat-' + app.inkey).focus();
      }, 100);
    },
    scroll() {
      UIkit.scroll('.headline2').scrollTo('.game');
    }
  },
  inject: ['http'],
  mounted() {
    this.startGame();
  },
  beforeDestroy() {
    //this.makeStats();
    this.$parent.commitVal(false, 'start')
  }
}
</script>

<style lang="scss" scoped>
.scores {
  margin-bottom: 10px;
}

.finish-block {
  margin-bottom: 20px;
}
</style>
